import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { PayrollService } from '../payroll.service';
import * as payrollActions from './payroll.actions'

@Injectable({
    providedIn: 'root'
})

export class PayrollEffects {
    constructor(
        private actions$: Actions,
        private payrollService: PayrollService,
        private toastr: ToastrService,
    ) {}

  fetchPayrolls$ = createEffect(() =>
    this.actions$.pipe(
      ofType(payrollActions.fetchPayrolls),
      exhaustMap((action) =>
        this.payrollService
          .fetchPayrolls(action.merchantId)
          .pipe(
            exhaustMap((response: any) => [
              payrollActions.fetchPayrollsSuccess({ payrolls: response}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(payrollActions.fetchPayrollsFailed())
            }
            )
          )
      )
    )
  );

  fetchPayroll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(payrollActions.fetchPayroll),
      exhaustMap((action) =>
        this.payrollService
          .fetchPayroll(action.merchantId, action.payrollId)
          .pipe(
            exhaustMap((response: any) => [
                payrollActions.fetchPayrollSuccess({ payroll: response}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(payrollActions.fetchPayrollFailed())
            }
            )
          )
      )
    )
  );

  createPayroll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(payrollActions.createPayroll),
      exhaustMap((action) =>
        this.payrollService
          .createPayroll(action.payrollDto)
          .pipe(
            exhaustMap((response: any) => [
                payrollActions.createPayrollSuccess(response),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(payrollActions.createPayrollFailed())
            }
            )
          )
      )
    )
  );

  updatePayroll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(payrollActions.updatePayroll),
      exhaustMap((action) =>
        this.payrollService
          .updatePayroll(action.payrollDto, action.payrollId)
          .pipe(
            exhaustMap((response: any) => [
                payrollActions.updatePayrollSuccess({response: response}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(payrollActions.updatePayrollFailed())
            }
            )
          )
      )
    )
  );
}